import elementHasFocus from '../elementHasFocus';

var elementOrDescendentHasFocus = function elementOrDescendentHasFocus(element) {
  return elementHasFocus(element) || element.contains(document.activeElement);
};

export default elementOrDescendentHasFocus;